import { reactive } from "@vue/reactivity"

const states = reactive({
    isSidebarClose: false,
    isUserClose: null,
    gettingStartedList: [],
    pipelineList: [],
})

const mutations = {
    switchSidebarClose: (status) => {
        states.isSidebarClose = !status;
    },
    switchUserClose: (status) => {
        states.isUserClose = !status;
    },
    setGettingStartedList: (list) => {
        states.gettingStartedList = list || [];
    },
    setPipelineList: (list) => {
        states.pipelineList = list || [];
    }
}

export default {
    states,
    mutations
}